<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <router-link tag="button" :to="{name: 'users.create'}" class="btn btn-info">
          <span class="btn-label">
            <i class="material-icons">add</i>
          </span>
          Novo
        </router-link>
      </div>
    </div>
    <!-- <FiltersSearch
      @filterName="filterName"
      @filterBranch="filterBranch"
      @resetFilters="resetFilters"
      @filterProfile="filterProfile"
    />-->
    <div class="row">
      <div class="col-md-12">
        <b-form
          @submit.prevent.stop="onSubmit"
          @reset.prevent.stop="resetFilters"
          novalidate="novalidate"
        >
          <div class="card">
            <div class="card-header card-header-icon card-header-rose">
              <div class="card-icon" v-b-toggle.filter>
                <i class="material-icons">search</i>
              </div>
              <h4 class="card-title">Filtros</h4>
            </div>
            <br />
            <b-collapse id="filter">
              <div class="card-body">
                <div class="row">
                  <div class="col-md-4">
                    <input
                      type="text"
                      placeholder="Buscar por Nome ou Login."
                      name="name"
                      v-model="form.textSearch"
                      class="form-control"
                      id="name"
                      autocomplete="off"
                    />
                  </div>
                  <div class="col-md-4">
                    <model-list-select
                      class="form-control"
                      :list="profiles"
                      option-value="id"
                      option-text="name"
                      v-model="form.profile_id"
                      placeholder="Perfil"
                    ></model-list-select>
                  </div>
                  <div class="col-md-4">
                    <model-list-select
                      class="form-control"
                      :list="branches"
                      option-value="id"
                      option-text="name"
                      v-model="form.branch_id"
                      placeholder="Loja"
                    ></model-list-select>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <button type="reset" class="btn btn-fill btn-outline-danger">Limpar Filtros</button>
                <button type="submit" class="btn btn-fill btn-rose">Filtrar</button>
              </div>
            </b-collapse>
          </div>
        </b-form>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header card-header-icon card-header-rose">
            <div class="card-icon">
              <i class="material-icons">list</i>
            </div>
            <h4 class="card-title">Lista</h4>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th class="text-center">#</th>
                    <th class="text-center">Código</th>
                    <th>Nome</th>
                    <th>Login</th>
                    <th>Perfil</th>
                    <th>Filial</th>
                    <th class="text-right">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-show="items.length > 0" v-for="iterator in items" :key="iterator.id">
                    <td class="text-center">{{ iterator.id }}</td>
                    <td class="text-center">{{ iterator.code }}</td>
                    <td v-html="formatTextSearch(iterator.name)"></td>
                    <td v-html="formatTextSearch(iterator.username)">{{ iterator.username }}</td>
                    <td
                      v-html="formatTextSearch( (iterator.profile ? iterator.profile.name : '') )"
                    ></td>
                    <td v-html="formatTextSearch( (iterator.branch ? iterator.branch.name : '') )"></td>
                    <td class="td-actions text-right">
                      <index-buttons
                        :iterator="iterator"
                        :showAudit="true"
                        :toAudit="{name: 'audits.index', query: { page: 1, functionality: 4, register: iterator.id}}"
                        :showEdit="true"
                        :toEdit="{name: 'users.edit', params: { id: iterator.id }}"
                        :showRemove="true"
                        dispatchRemove="users/rem"
                        :callbackRemove="getData"
                      ></index-buttons>
                    </td>
                  </tr>
                  <tr v-show="items.length==0">
                    <td colspan="5">Nenhum perfil encontrado!</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="card-footer" v-show="items.length">
            <div class="row" style="width:100%;">
              <div class="col-sm-4">
                <model-list-select
                  class="form-control"
                  :list="limits"
                  option-value="limit"
                  option-text="text"
                  v-model="limit"
                  @input="onSubmit($event)"
                ></model-list-select>
              </div>
              <div class="col-sm-4 text-center">
                <b-pagination
                  order="is-right"
                  v-show="items.length > 0"
                  v-model="currentPage"
                  :simple="false"
                  :per-page="limit"
                  :total-rows="total"
                  @change="pageChange"
                ></b-pagination>
              </div>
              <div class="col-sm-4 text-right text-secondary">{{ to }} registros de {{ total }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import FiltersSearch from "./FiltersSearch";
import JwtService from "@/services/jwt.service";
import UserService from "@/services/modules/users.service";
export default {
  // components: { FiltersSearch },
  computed: {
    items: {
      set(_items) {},
      get() {
        return this.$store.state.users.itens;
      },
    },
    profiles: {
      set(_profiles) {},
      get() {
        return this.$store.state.profiles.itens;
      },
    },
    branches: {
      set(_branches) {},
      get() {
        return this.$store.state.branches.itens;
      },
    },
  },
  data() {
    return {
      currentPage: 1,
      form: {
        branch_id: null,
        profile_id: null,
        textSearch: "",
      },
      _items: [],
      limit: null,
      limits: [
        { limit: 5, text: "Exibir 5(cinco) por página" },
        { limit: 10, text: "Exibir 10(dez) por página" },
        { limit: 25, text: "Exibir 25(vinte e cinco) por página" },
        { limit: 50, text: "Exibir 50(cinquenta) por página" },
      ],
      total: 0,
      to: 0,
      textSearch: "",
    };
  },
  created: function () {
    var self = this;
    self.initQueryString();
    this.getBranches();
    this.getProfiles();
    self.$root.$on("changeBranch", self.getData);
    setTimeout(() => (this.items = this._items), 500);
    setTimeout(self.pageChange(1), 500);
  },
  methods: {
    formatTextSearch(name) {
      let re = new RegExp("(" + this.textSearch + ")", "ig");
      return name.replace(re, "<b><u>$1</u></b>");
    },
    filterName(name) {
      this.textSearch = name;
      let re = new RegExp(name, "ig");
      this.items = this._items.filter(
        (item) =>
          re.test(item.name) ||
          re.test(item.branch ? item.branch.name : "") ||
          re.test(item.profile ? item.profile.name : "") ||
          re.test(item.username)
      );
    },
    async getBranches() {
      var self = this;

      self.$root.$emit("onLoading");
      const response = self.$store.dispatch("branches/all");

      response.then(function () {
        self.$root.$emit("onLoading");
      });

      response.catch(function () {
        self.$root.$emit("onLoading");
      });
    },
    async getProfiles() {
      var self = this;

      self.$root.$emit("onLoading");

      const response = self.$store.dispatch("profiles/all");

      response.then(function () {
        self.$root.$emit("onLoading");
      });

      response.catch(function () {
        self.$root.$emit("onLoading");
      });
    },
    filterBranch(id) {
      this.items = this._items.filter((item) => item.branch_id == id);
    },
    filterProfile(id) {
      this.items = this._items.filter((item) => item.profile_id == id);
    },
    resetFilters() {
      this.form.textSearch = "";
      this.form.branch_id = null;
      this.form.profile_id = null;
      this.getData();
    },
    async getData() {
      var self = this;

      self.$root.$emit("onLoading");

      setTimeout(function () {
        const response = self.$store.dispatch("users/all", {
          limit: self.limit,
          currentPage: self.currentPage,
          isPaginate: true,
          params: self.form,
        });

        response.then(function (_pagination) {
          self.items = _pagination;
          self.total = _pagination.total;
          self.to = _pagination.to;
          self.$root.$emit("onLoading");
        });

        response.catch(function () {
          self.$root.$emit("onLoading");
          self.$notify.error("Falha na comunicação com a API!");
        });
      }, 200);
    },
    pageChange(_pageNum) {
      var self = this;

      self.currentPage = _pageNum;

      self.setQueryString();

      self.getData();
    },
    onSubmit(_ev = null) {
      if (isNaN(_ev)) _ev.preventDefault();

      var self = this;

      self.setQueryString();

      self.getData();
    },
    setQueryString() {
      var self = this;

      self.$router.push({
        name: "users.index",
        query: {
          limit: self.limit ? self.limit : 5,
          currentPage: self.currentPage,
        },
      });
    },
    initQueryString() {
      var self = this;
      var query = self.$route.query;

      self.limit = 5;
      if (query.limit) {
        self.limit = parseInt(query.limit);
      }
      if (query.currentPage) {
        setTimeout(function () {
          self.pageChange(parseInt(query.currentPage));
        }, 900);
      }
    },
  },
  destroyed() {
    var self = this;
    self.$root.$off("changeBranch", self.getData());
  },
};
</script>
